export const MEDIA_MOBILE_BREAKPOINT: number = 56.25;
export const LETTER_SPACING: number = -0.025;
